(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-footer"] && !Shopify.designMode) return;
  try {
    
  // Desktop: force footer accordions open; mobile: respect merchant defaults.
  (function () {
    const mq = window.matchMedia('(min-width: 990px)');
    const cols = document.querySelectorAll('.mm-footer__col');
    const apply = () => {
      cols.forEach((d) => {
        if (mq.matches) {
          d.dataset.mmWasOpen = d.open ? '1' : '0';
          d.open = true;
        } else if (d.dataset.mmWasOpen !== undefined) {
          d.open = d.dataset.mmWasOpen === '1';
        }
      });
    };
    apply();
    mq.addEventListener('change', apply);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-main-policy"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-mm-policy]');
    if (!root) return;
    const content = root.querySelector('[data-mm-policy-content]');
    const toc = root.querySelector('[data-mm-toc]');
    const heads = content.querySelectorAll('h2');
    if (!heads.length) {
      root.querySelector('.mm-policy__toc')?.remove();
      return;
    }
    heads.forEach((h, i) => {
      if (!h.id) h.id = 'section-' + (i + 1);
      const text = h.textContent.replace(/^\d+\.\s*/, '');
      h.textContent = i + 1 + '. ' + text;
      const li = document.createElement('li');
      li.innerHTML = `<a href="#${h.id}">${i + 1}. ${text}</a>`;
      toc.appendChild(li);
    });
    const links = toc.querySelectorAll('a');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          links.forEach((a) => a.classList.toggle('is-current', a.getAttribute('href') === '#' + en.target.id));
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    heads.forEach((h) => io.observe(h));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-order-tracking"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-mm-track]');
    if (!root) return;
    const form = root.querySelector('[data-mm-track-form]');
    const endpoint = root.getAttribute('data-endpoint') || '';
    const wa = root.getAttribute('data-whatsapp') || '';
    const states = root.querySelectorAll('[data-mm-track-state]');
    const show = (name) => states.forEach((s) => s.toggleAttribute('hidden', s.getAttribute('data-mm-track-state') !== name));
    const btn = root.querySelector('[data-mm-track-btn]');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const order = form.order.value.trim().replace(/^#/, '');
      const phone = form.phone.value.trim();
      root.querySelectorAll('[data-mm-track-order]').forEach((el) => (el.textContent = '#' + order));
      const msg = encodeURIComponent(`Hello Mummy & Munchkin!\nWhere is my order?\n\nOrder number: #${order}\nPhone: ${phone}`);
      root.querySelectorAll('[data-mm-track-wa]').forEach((a) => (a.href = `https://wa.me/${wa}?text=${msg}`));
      if (!endpoint) {
        show('handoff');
        return;
      }
      const url = endpoint.replace('{order}', encodeURIComponent(order)).replace('{phone}', encodeURIComponent(phone));
      if (!/\{json\}/.test(endpoint)) {
        window.location.href = url;
        return;
      }
      show('loading');
      btn.textContent = 'Tracking…';
      try {
        const res = await fetch(url.replace('{json}', ''), { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('not found');
        const data = await res.json();
        const el = root.querySelector('[data-mm-track-state="result"]');
        el.innerHTML = `<div class="mm-track__banner"><span class="mm-track__banner-eyebrow">${data.eyebrow || 'Status'}</span><span class="mm-track__banner-title">${data.title || ''}</span><span>${data.subtitle || ''}</span></div>` +
          (Array.isArray(data.steps) ? `<ol class="mm-track__steps">${data.steps.map((s) => `<li class="mm-track__step${s.done ? ' is-done' : ''}${s.current ? ' is-current' : ''}"><span class="mm-track__dot"></span><span class="mm-track__step-text"><b>${s.label}</b><small>${s.date || ''}</small></span></li>`).join('')}</ol>` : '');
        show('result');
      } catch (err) {
        show('notfound');
      } finally {
        btn.textContent = 'Track Order';
      }
    });
    root.addEventListener('click', (e) => {
      if (!e.target.closest('[data-mm-track-reset]')) return;
      show('none');
      form.reset();
      form.order.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mm-recs]').forEach((el) => {
    if (el.dataset.loaded) return;
    el.dataset.loaded = '1';
    const io = new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        io.disconnect();
        fetch(el.getAttribute('data-url'))
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fresh = doc.querySelector('[data-mm-recs]');
            if (fresh && fresh.innerHTML.trim()) {
              el.innerHTML = fresh.innerHTML;
              document.dispatchEvent(new CustomEvent('mm:grid:update'));
            } else {
              el.remove();
            }
          })
          .catch(() => {});
      },
      { rootMargin: '400px' }
    );
    io.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-same-category"] && !Shopify.designMode) return;
  try {
    
  // Shuffle the rendered pool and reveal `limit` cards, so the mix changes on every visit.
  document.querySelectorAll('[data-mm-samecat]').forEach((el) => {
    if (el.dataset.shuffled) return;
    el.dataset.shuffled = '1';
    const grid = el.querySelector('[data-mm-samecat-grid]');
    const limit = parseInt(el.getAttribute('data-limit'), 10) || 8;
    const items = Array.from(grid.children);
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }
    items.forEach((item, i) => {
      item.toggleAttribute('hidden', i >= limit);
      grid.appendChild(item);
    });
    document.dispatchEvent(new CustomEvent('mm:grid:update'));
  });

  } catch(e) { console.error(e); }
})();
})();
